import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconSave = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--save")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M16,2 C16.2652165,2 16.5195704,2.10535684 16.7071068,2.29289322 L21.7071068,7.29289322 C21.8946432,7.4804296 22,7.73478351 22,8 L22,19 C22,20.6568542 20.6568542,22 19,22 L5,22 C3.34314575,22 2,20.6568542 2,19 L2,5 C2,3.34314575 3.34314575,2 5,2 L16,2 Z M15.5857864,4 L8,4 L8,7 L15,7 C15.5522847,7 16,7.44771525 16,8 C16,8.55228475 15.5522847,9 15,9 L15,9 L7,9 C6.44771525,9 6,8.55228475 6,8 L6,8 L6,4 L5,4 C4.44771525,4 4,4.44771525 4,5 L4,19 C4,19.5522847 4.44771525,20 5,20 L6,20 L6,13 C6,12.4871642 6.38604019,12.0644928 6.88337887,12.0067277 L7,12 L17,12 C17.5522847,12 18,12.4477153 18,13 L18,13 L18,20 L19,20 C19.5522847,20 20,19.5522847 20,19 L20,8.41421356 L15.5857864,4 Z M16,14 L8,14 L8,20 L16,20 L16,14 Z" id="icon--centivo--save"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-673.000000, -1085.000000)"/>
          <g id="Icon/save">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--save"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--save"/>
          </g>
      </g>
  </IconWrapper>
)
